import { render, staticRenderFns } from "./KryptoLicenseUpdateButton.vue?vue&type=template&id=4a238f6f&scoped=true"
import script from "./KryptoLicenseUpdateButton.vue?vue&type=script&lang=js"
export * from "./KryptoLicenseUpdateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a238f6f",
  null
  
)

export default component.exports